import { render, staticRenderFns } from "./price-bubble.vue?vue&type=template&id=3bf6a7b0&"
import script from "./price-bubble.vue?vue&type=script&lang=js&"
export * from "./price-bubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports